import { createRouter, createWebHistory } from 'vue-router'
import * as CryptoJS from 'crypto-js';

///general file views
import NotFound from "../views/NotFound.vue"

///client file views
import Dashbord from "../views/Dashbord.vue"
import Store from "../views/Store.vue"
import Order from "../views/Order.vue"
import Sales from '../views/Sales.vue';
import Clients from '../views/Clients.vue';
import Messages from '@/views/Messages.vue';
import Cancelation from '@/views/Cancelation.vue';
import EditProduct from '@/views/EditProduct.vue';
import Staffs from '@/views/Staffs.vue';
import Profile from '@/views/profile.vue';
/*import Outgoing_parcel from "../views/client/OutgoingParcel.vue"
import Destinations from "../views/client/Destination.vue"
import Staffs from "../views/client/Staffs.vue"
import Customers from "../views/client/Customer.vue"
import Profile from "../views/client/Profile.vue"

import Revenue_Report from "../views/client/ReportRevenue.vue"
import Transit_Report from "../views/client/ReportTransit.vue"
import Received_Report from "../views/client/ReportReceived.vue"
import Removed_Report from "../views/client/ReportRemoved.vue"
import Message_Report from "../views/client/ReportMassage.vue"

///admin file views
import Admin_dashbord from "../views/admin/Admin_Dashbord.vue"
import Active_Company from "../views/admin/ActiveCompany.vue"
import Expired_Company from "../views/admin/ExpiredCompany.vue"
import Messaging from "../views/admin/Messaging.vue"
import Admin_profile from "../views/admin/ProfilePage.vue"*/

var user_cry = localStorage.getItem("user")  || "";
var user = CryptoJS.AES.decrypt(user_cry, 'user').toString(CryptoJS.enc.Utf8) || null
user = JSON.parse(user)

function authManager(){
  if(user){
    //user = JSON.parse(user)
    if(user.role == 3){
      return true
    }else{
      if(user.role < 3){
        return {name:'Dashbord'}
      }else{
        return {name:'NotParmit'}
      }
    }
  }else{
    return {name:'admindashbord'}
  }
}

function authAdmin(){
  if(user){
    //user = JSON.parse(user)
    if(user.role == 1){
      return true
    }else{
        return {name:'Dashbord'}
    }
  }else{
    return {name:'Dashbord'}
  }
}
//only operators and adminsa
function authOppsAdmin(){
  if(user){
    //user = JSON.parse(user)
    if(user.role < 3 ){

      return true
    }else{

     return {name:'Dashbord'}
    }
  }else{
    return {name:'Dashbord'}
  }
}

function authClient(){
  if(user){
    
    if(user.role < 4 ){
      return true
    }else{
      
        return {name:'NotParmit'}
    }
  }else{
    return {name:'Dashbord'}
  }
}

const routes = [
  {
    path: "/:pathMatch(.*)*",
    name: "NotParmit",
    component: NotFound,
  },
  {
    path: '/',
    beforeEnter:authClient,
    name: 'Dashbord',
    component: Dashbord
  },
  {
    path: '/store',
    beforeEnter:authOppsAdmin,
    name: 'store',
    component: Store
  },
  {
    path: '/order',
    beforeEnter:authClient,
    name: 'order',
    component: Order
  },
  {
    path: '/edit-product',
    beforeEnter:authClient,
    name: 'edit_product',
    component: EditProduct
  },
   {
    path: '/sales',
    beforeEnter:authAdmin,
    name: 'sales',
    component: Sales
  },
   {
    path: '/canceled-order',
    beforeEnter:authAdmin,
    name: 'cancel',
    component: Cancelation
  },
  {
    path: '/clients',
    beforeEnter:authOppsAdmin,
    name: 'clients',
    component: Clients
  },
  {
    path: '/messages',
    beforeEnter:authOppsAdmin,
    name: 'messages',
    component: Messages
  },
  {
    path: '/staffs',
    beforeEnter:authClient,
    name: 'staffs',
    component: Staffs
  },
  {
    path: '/profile',
    beforeEnter:authClient,
    name: 'profile',
    component: Profile
  }
  /*{
    path: '/customers',
    beforeEnter:authAdmin,
    name: 'customers',
    component: Customers
  },
  {
    path: '/revenue-report',
    beforeEnter:authOnlyAdmin,
    name: 'revenue_report',
    component: Revenue_Report
  },
  {
    path: '/transit-report',
    beforeEnter:authAdmin,
    name: 'transit_report',
    component: Transit_Report
  },
  {
    path: '/received-report',
    beforeEnter:authAdmin,
    name: 'received_report',
    component: Received_Report
  },
  {
    path: '/removed-report',
    beforeEnter:authOnlyAdmin,
    name: 'removed_report',
    component: Removed_Report
  },
  {
    path: '/message-report',
    beforeEnter:authOnlyAdmin,
    name: 'message_report',
    component: Message_Report
  },
  {
    path: '/profile',
    beforeEnter:authClient,
    name: 'profile',
    component: Profile
  },
  {
    path: '/admin',
    beforeEnter:authManager,
    name: 'admindashbord',
    component: Admin_dashbord
  },
  {
    path: '/active-companies',
    beforeEnter:authManager,
    name: 'activecompany',
    component: Active_Company
  },
  {
    path: '/expired-companies',
    beforeEnter:authManager,
    name: 'expiredcompany',
    component: Expired_Company
  },
  {
    path: '/messaging',
    beforeEnter:authManager,
    name: 'messaging',
    component: Messaging
  },
  {
    path: '/admin-profile',
    beforeEnter:authManager,
    name: 'admin-profile',
    component: Admin_profile
  },
  
  {
    path: '/addstudent',
    name: 'Addstudent',
    component: AddStudent
  }*/
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
